import { useLayoutEffect, useState } from 'react';

function useVisualViewport() {
  const [visualWindowSize, setWindowSize] = useState({
    width: window?.visualViewport?.width || 0,
    height: window?.visualViewport?.height || 0,
  });

  useLayoutEffect(() => {
    const handler = () => {
      setWindowSize({
        width: window?.visualViewport?.width || 0,
        height: window?.visualViewport?.height || 0,
      });
    };
    handler();
    window?.visualViewport?.addEventListener('resize', handler);

    return () => {
      window?.visualViewport?.removeEventListener('resize', handler);
    };
  }, []);

  return {
    ...visualWindowSize,
    isObstructed: visualWindowSize.height < 500,
  };
}

export default useVisualViewport;
